// vue
import { ref } from '@vue/composition-api';
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import { TeeSchema as TeeSchemaInterface, 
         CustomCourse as CustomCourseInterface, 
         CoursesPerSite as CoursesPerSiteInterface } from '@/vue3/api/models/';

const getCourseTypeParam = (isCustom:boolean = false) => {
    if(isCustom){
        return 'custom';
    }
    return 'default'
}

export const useWHSTeeParamsService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // reactive

    // methods
    const getAllWHSTeeParamsByCourse = async (course_id: number, is_custom: boolean = false): Promise<TeeSchemaInterface[]> => {
        const course_type = getCourseTypeParam(is_custom);
        const res = await axios.get(`${apiUrl}/whs-tee-params/${course_type}/course/${course_id}`);
        return res.data;
    };

    const getWHSTeeParam = async (id: number, is_custom: boolean = false): Promise<TeeSchemaInterface> => {
        const course_type = getCourseTypeParam(is_custom);
        const res = await axios.get(`${apiUrl}/whs-tee-params/${course_type}/${id}`);
        return res.data;
    };

    const deleteWHSTeeParam = async (id: number, is_custom: boolean = false) => {
        const course_type = getCourseTypeParam(is_custom);
        const res = await axios.deleteId(`${apiUrl}/whs-tee-params/${course_type}/${id}`);
        return res.status;
    };

    const createWHSTeeParam = async (tee_param: TeeSchemaInterface): Promise<TeeSchemaInterface[]> => {
        const payload = {...tee_param, courseSchemaId: tee_param.courseSchemaId.id}
        const course_type = getCourseTypeParam(tee_param.courseSchemaId.isCustom);
        const res = await axios.post(`${apiUrl}/whs-tee-params/${course_type}`, payload);
        return res.data;
    };

    const updateWHSTeeParam = async (tee_param: TeeSchemaInterface): Promise<TeeSchemaInterface[]> => {
        const payload = {...tee_param, courseSchemaId: tee_param.courseSchemaId.id}
        const course_type = getCourseTypeParam(tee_param.courseSchemaId.isCustom);
        const res = await axios.put(`${apiUrl}/whs-tee-params/${course_type}`, payload);
        return res.data;
    };

    const addWHSCustomCourse = async (course_data: CustomCourseInterface): Promise<number> => {
        const res = await axios.post(`${apiUrl}/whs-hublink/course/custom`, course_data)
        if(res && (res.status == 200 || res.status == 201) && res.data){
            return res.data;    //data = id
        }
        return 0;
    }

    const getWHSAllCourses = async (): Promise<CoursesPerSiteInterface[]> => {
        try{
            const res = await axios.get(`${apiUrl}/whs-hublink/courses/all`)
            if(res && res.status == 200 && res.data){
                return res.data;
            }
            return [];
        }
        catch(e){
            console.log(e)
            return []
        }

    }


    return {
        getAllWHSTeeParamsByCourse,
        deleteWHSTeeParam,
        createWHSTeeParam,
        updateWHSTeeParam,
        getWHSTeeParam,
        addWHSCustomCourse,
        getWHSAllCourses
    };
};
